module.exports = __webpack_public_path__ + "static/media/11.9bb04315.png";